export default [
  {
    path: 'compras',
    name: 'pos.compras',
    redirect: { name: 'pos.compra.factura' },
    component: () => import('@/views/pos/compras/ComprasEmpresaLayout.vue'),
    children: [
      // Dashboard o vista general de compras
      {
        path: '',
        name: 'pos.comprasListado',
        component: () => import('@/views/pos/compras/ComprasEmpresaListado.vue'),
      },

      // 📦 Pedidos
      {
        path: 'pedido',
        name: 'pos.comprasPedidoListado',
        component: () => import('@/views/pos/compras/pedido/CompraPedidoEmpresaHome.vue'),
      },
      {
        path: 'pedido/registrar',
        name: 'pos.comprasPedidoRegistrar',
        component: () => import('@/views/pos/compras/pedido/CompraPedidoEmpresaRegistrar.vue'),
      },
      {
        path: 'pedido/:uuid_pedido',
        name: 'pos.comprasPedidoConsultar',
        component: () => import('@/views/pos/compras/pedido/CompraPedidoEmpresaConsultar.vue'),
      },
      {
        path: 'pedido/:uuid_pedido/editar',
        name: 'pos.comprasPedidoEditar',
        component: () => import('@/views/pos/compras/pedido/CompraPedidoEmpresaEditar.vue'),
      },

      // 🧾 Facturas


      {
        path: 'factura',
        name: 'pos.compra.factura',
        component: () => import('@/views/pos/compras/factura/POSCompraFacturaEmpresaHome.vue'),

      },
      {
        path: 'factura/registrar',
        name: 'pos.compra.factura.registrar',
        component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaRegistrar.vue'),

      },
      {
        path: 'factura/:uuid_factura',
        name: 'pos.comprasFacturaConsultar',
        component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaConsultar.vue'),

      },
      {
        path: 'factura/:uuid_factura/editar',
        name: 'pos.comprasFacturaEditar',
        component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaEditar.vue'),

      },

      // 📄 Remitos
      {
        path: 'remito',
        name: 'pos.comprasRemitoListado',
        component: () => import('@/views/pos/compras/remito/CompraRemitoEmpresaHome.vue'),
      },
      {
        path: 'remito/registrar',
        name: 'pos.comprasRemitoRegistrar',
        component: () => import('@/views/pos/compras/remito/CompraRemitoEmpresaRegistrar.vue'),
      },
      {
        path: 'remito/:uuid_remito',
        name: 'pos.comprasRemitoConsultar',
        component: () => import('@/views/pos/compras/remito/CompraRemitoEmpresaConsultar.vue'),
      },
      {
        path: 'remito/:uuid_remito/editar',
        name: 'pos.comprasRemitoEditar',
        component: () => import('@/views/pos/compras/remito/CompraRemitoEmpresaEditar.vue'),
      },

    ],
  },
]
